import React, { useEffect } from 'react';

const CalendlyBooking = () => {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
      link.remove();
    };
  }, []);

  return (
    <div className="booking-container" style={{ padding: '20px', display: 'flex', justifyContent: 'center' }}>
      <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/savesecurities/save-demo-meeting"
        style={{
            minWidth: '320px', 
            height: '750px', 
            width: '100%', 
            maxWidth: '1000px',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}
      ></div>
    </div>
  );
};

export default CalendlyBooking;